import { atom, useAtom, useAtomValue } from "jotai";

export const optionSizeAtom = atom<string>("");

export const optionSizeNumAtom = atom((get) => Number(get(optionSizeAtom)));

export const useOptionSize = () => {
  const [optionSize, setOptionSize] = useAtom(optionSizeAtom);
  const optionSizeNum = useAtomValue(optionSizeNumAtom);

  return {
    optionSize,
    optionSizeNum,
    setOptionSize,
  };
};
